// Tool-Modus fuer den Canvas. Default "sticky" — der Walking-Skeleton-Klick legt
// damit weiterhin Stickies. Tool Rail in S4.7 visualisiert die Auswahl.

import { useEffect, useState } from "react";

export type Tool =
  | "select"
  | "sticky"
  | "text"
  | "shape-rect"
  | "arrow"
  | "requirement"
  | "pain"
  | "dependency"
  | "frame"
  | "mindmap-node"
  | "shape"
  | "icon";

export const TOOL_KEYS: Record<string, Tool> = {
  v: "select",
  s: "sticky",
  t: "text",
  a: "arrow",
  q: "requirement",
  p: "pain",
  d: "dependency",
  f: "frame",
  m: "mindmap-node",
  h: "shape",
  i: "icon",
};

export function useTool(initial: Tool = "sticky"): {
  tool: Tool;
  setTool: (next: Tool) => void;
} {
  const [tool, setTool] = useState<Tool>(initial);

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (isTypingTarget(e.target)) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const next = TOOL_KEYS[e.key.toLowerCase()];
      if (next) {
        e.preventDefault();
        setTool(next);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return { tool, setTool };
}

export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable;
}
